module.exports = __webpack_public_path__ + "img/gtax_mv2022.ec41fab.png";